import fetch from '../../fetch';

export default async function startWompiPayment(reservationId) {
  const response = await fetch('/wompi/checkout', {
    method: 'post',
    credentials: 'include',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ reservationId }),
  });
  const result = await response.json();
  if (response.ok && result.checkoutUrl) {
    window.location.assign(result.checkoutUrl);
    return { status: 200 };
  }
  return { status: result.status || response.status, errorMessage: result.errorMessage || 'No se pudo iniciar el pago con Wompi.' };
}
